import React, { useState, useEffect } from 'react';
import ScissorsIcon from '@/assets/scissors-light.svg';
import CopyIcon from '@/assets/copy-simple-light.svg';

interface TextSelectionProviderProps {
  children: React.ReactNode;
  pageId?: string;
  pageTitle?: string;
  onSaveToScrapbook?: (extractData: any) => void;
  isAuthenticated?: boolean;
  showSaveToScrapbook?: boolean;
}

const TextSelectionProvider: React.FC<TextSelectionProviderProps> = ({
  children,
  pageId = '',
  pageTitle = '',
  onSaveToScrapbook,
  isAuthenticated = false,
  showSaveToScrapbook = false,
}) => {
  const [selectedText, setSelectedText] = useState('');
  const [isMenuVisible, setIsMenuVisible] = useState(false);
  const [menuPosition, setMenuPosition] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const handleMouseUp = () => {
      setTimeout(() => {
        const selection = window.getSelection();
        const text = selection?.toString().trim() || '';

        if (text && selection && selection.rangeCount > 0) {
          const range = selection.getRangeAt(0);
          const endRange = range.cloneRange();
          endRange.collapse(false); // Collapse to end
          const rect = endRange.getBoundingClientRect();
          setSelectedText(text);
          setMenuPosition({
            x: rect.left + window.scrollX,
            y: rect.bottom + window.scrollY + 5,
          });
          setIsMenuVisible(true);
        } else {
          setIsMenuVisible(false);
        }
      }, 10);
    };

    const handleMouseDown = (event: MouseEvent) => {
      const target = event.target as Element;
      if (!target.closest('[data-text-selection-menu]')) {
        setIsMenuVisible(false);
      }
    };

    document.addEventListener('mouseup', handleMouseUp);
    document.addEventListener('mousedown', handleMouseDown);

    return () => {
      document.removeEventListener('mouseup', handleMouseUp);
      document.removeEventListener('mousedown', handleMouseDown);
    };
  }, []);

  const handleCopy = async () => {
    await navigator.clipboard.writeText(selectedText);
    setIsMenuVisible(false);
  };

  const handleSaveToScrapbook = () => {
    if (!selectedText || !pageId) {
      return;
    }

    const extractData = {
      path: `report-extract.${pageId}.${Date.now()}.json`,
      contentType: 'application/x.stylus.article.extract+json',
      content: JSON.stringify({
        pageId,
        pageTitle,
        extract: selectedText,
      }),
    };
    onSaveToScrapbook?.(extractData);
    setIsMenuVisible(false);
  };
  return (
    <>
      {children}
      {isMenuVisible && (
        <div
          className="fixed flex h-[58px] rounded bg-white shadow-md"
          style={{
            top: menuPosition.y - window.scrollY,
            left: menuPosition.x - window.scrollX,
            zIndex: 999999,
          }}
          data-text-selection-menu
        >
          {isAuthenticated && (
            <div onClick={handleCopy} className="grid cursor-pointer items-center px-3 py-1">
              <CopyIcon className="h-7 w-7" />
              <div className="text-sm">Copy</div>
            </div>
          )}
          {showSaveToScrapbook && (
            <div onClick={handleSaveToScrapbook} className="grid cursor-pointer items-center px-3 py-1">
              <ScissorsIcon className="h-7 w-7" />
              <div className="text-sm">Save</div>
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default TextSelectionProvider;
